import React, { Component } from 'react';

import '../App.css';

class Sheet7 extends Component {
  render() {
    return(
      <div className="typo">
        <div className="typo-bg-7">
          <h1>White Widow</h1>
        </div>
        <div className="typo-spec-col">
          <ul>
            <li><h4>CBD</h4></li>
            <li><p>12%</p></li>
          </ul>

          <ul>
            <li><h4>THC</h4></li>
            <li><p>0,2%</p></li>
          </ul>
          <ul>
            <li><h4>Prezzo al grammo:</h4></li>
            <li><p>10 €</p></li>
          </ul>

          <ul>
            <li><h4>Formati da:</h4></li>
            <li><p>2, 10, 20 g</p></li>
          </ul>
          </div>
    </div>
    )
  }
}

export default Sheet7;
